import { FC, ReactNode } from 'react';

import { Button } from '@/general/components/Button/Button';
import { Image } from '@repo/ui/Image';

import { getSigninUrl } from './ssoHelper';

const carmaAuthApi = `${process.env.NEXT_PUBLIC_AUTH_BASE_API_URL}/auth/facebook`;

type Props = {
  redirectUrl?: string;
  label: ReactNode;
};

const getSSOUrl = (redirectUrl?: string): string | null => {
  const signinUrl = getSigninUrl(redirectUrl);
  const queryParams = new URLSearchParams({
    client_id: process.env.NEXT_PUBLIC_FACEBOOK_AUTH_CLIENT_ID ?? '',
    redirect_uri: carmaAuthApi,
    state: btoa(signinUrl),
    scope: 'email',
  }).toString();
  return `https://www.facebook.com/v18.0/dialog/oauth?${queryParams}`;
};

export const SSOFacebook: FC<Props> = ({ redirectUrl, label }) => {
  const ssoUrl = getSSOUrl(redirectUrl);

  if (!ssoUrl) {
    return null;
  }

  return (
    <Button href={ssoUrl ?? ''} target="_self" fullWidth variant="secondary" size="medium">
      <span className="flex items-center gap-2">
        <span className="-my-4 block">
          <Image src="/images/facebook.svg" width={24} height={24} alt="" />
        </span>
        {label}
      </span>
    </Button>
  );
};
